import * as React from 'react'
import './cards.less'

class Cards extends React.Component {
  render () {
    return (
      <div className="c_cards">
        <div className="container">
          <p className='title'>{this.props.title}</p>
          <p className="count">
            <span>{this.props.count}</span>
            
          </p>
          <p className="time">
            <span>{this.props.describe}</span>
          </p>
        </div>
      </div>
    )
  }
}

export default Cards